import { useEffect, useState } from "react";

import { UserRoles } from "@intelligems/ig-types";

import { ADMINS_HAVE_FULL_ACCESS } from "../../components/ScopeWrappers/Scopes";
import { useGetOrg } from "../organizations/get-organization";

import { useLoggedInUser } from "./login";

export const useIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useState<boolean | undefined>(undefined);
  const user = useLoggedInUser();
  const org = useGetOrg();

  let userRoles: UserRoles[] | undefined = undefined;

  if (user.isSuccess) {
    userRoles = user.data?.user?.organizations
      ? user.data.user.organizations.find((o) => o.id === org.data.org.id)
          ?.roles || ["member"]
      : ["member"];
  }

  useEffect(() => {
    if (userRoles !== undefined) {
      setIsAdmin(
        !ADMINS_HAVE_FULL_ACCESS
          ? false
          : userRoles.some((p) => p === "intelligems")
      );
    }
  }, [org.data.org.id, user.isSuccess, user.data, userRoles]);

  return isAdmin;
};
